'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { NO_COUPON } from '@/constants/cart'
import { useCouponStore } from '@/stores/useCouponStore'

/**
 * Grava o cupom da URL (`?coupon=`) no store; sem o parâmetro, "Sem cupom". Fica fora do layout raiz e dentro de
 * `<Suspense>`: `useSearchParams` fora de Suspense leva a página estática inteira para renderização no navegador.
 */
const CouponFromUrl: React.FC = () => {
    const searchParams = useSearchParams()
    const setCouponName = useCouponStore((state) => state.setCouponName)

    // biome-ignore lint/correctness/useExhaustiveDependencies: só a URL de entrada na loja escolhe o cupom; rodar a cada navegação trocaria o cupom escolhido por "Sem cupom"
    useEffect(() => {
        setCouponName(searchParams.get('coupon') || NO_COUPON)
    }, [])

    return null
}

export default CouponFromUrl
